export const KitchenStatus = {
  PENDING: 0,
  ACCEPT: 1,
  REJECT: 2,
  ACTIVE: 3,
  INACTIVE: 4,
};
